module.exports = "/_next/static/images/b1b78c4284eefeb814fb8dd33cd449a6-credit-card-limit@3x.png.webp";